import { numberToPrettyString } from '@cian/utils';

import { NBSP } from 'shared/constants/symbols';

export const formatNumberToPrettyString = (value: number): string => {
  return numberToPrettyString(value).replace(/ /g, NBSP);
};
